import { yupResolver } from '@hookform/resolvers/yup';
import React, { memo, useEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import RadioRhf from '../../../ReactHookForm/RadioRhf/RadioRhf';
import * as yup from 'yup';
import { RadioOptionRhf } from '../../../ReactHookForm/RadioRhf/RadioOptionRhf';
import { useDispatch } from 'react-redux';
import { setHandleValidateRetrackEndReason, setRetrackEndReasonData } from '../../../../store/Retrack/RetrackSlice';
import { useLang } from '../../../../util/lang';

const RetrackEndReasonInput = () => {
    const dispatch = useDispatch();
    const get = useLang();

    const methods = useForm({
        resolver: yupResolver(
            yup.object().shape({
                retrackEndOption: yup.string().required('Choose one option'),
            })
        ),
        mode: 'onChange',
    });

    const onSubmit = (data) => {
        let submitData = { ...data };
        dispatch(setRetrackEndReasonData(submitData.retrackEndOption));
    };

    useEffect(() => {
        dispatch(setHandleValidateRetrackEndReason(methods.handleSubmit(onSubmit)));
    }, []);

    return (
        <FormProvider {...methods}>
            {/* Choice 1 */}
            <RadioRhf
                question={''}
                name={'retrackEndOption'}
                formControlLabelRhf={
                    <RadioOptionRhf
                        value={'option.newToothShapeDetected'}
                        label={get('@PatientInfo.log.RETRACK_END_REASON.option.newToothShapeDetected')}
                    />
                }
            />

            {/* Choice 2 */}
            <RadioRhf
                question={''}
                name={'retrackEndOption'}
                formControlLabelRhf={
                    <RadioOptionRhf
                        value={'option.iprNotInAccordance'}
                        label={get('@PatientInfo.log.RETRACK_END_REASON.option.iprNotInAccordance')}
                    />
                }
            />

            {/* Debug button*/}
            {/* <Button variant="contained" onClick={methods.handleSubmit(onSubmit)} style={{ marginTop: 16 }}>
                Submit
            </Button> */}
        </FormProvider>
    );
};

export default memo(RetrackEndReasonInput);
